<template>
	<dialog-slot
			title="Add new broker"
			@updateClose="onClose"
			@updateSave="onSave"
			width="340px"
			apply-text="Save"
			:preloader="isPreloader"
	>
		<div class="groupField_wrap">
			<field
					margin="0 0 10px"
					label="Broker name"
					placeholder="Enter new broker"
					@updateInput="onInput($event, 'brokerLocal')"
					:setInputValue="brokerLocal"
					is-required
					:classError="isFieldErr('brokerLocal')"
			></field>

			<field
					margin="0"
					label="Broker MC"
					placeholder="Enter broker mc"
					@updateInput="onInput($event, 'mcLocal')"
					:setInputValue="mcLocal"
					is-required
					:classError="isFieldErr('mcLocal')"
			></field>
		</div>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "DialogCreatingBroker",
	components: { DialogSlot },

	mixins: [ validationMixin ],

	props: {
		newBroker: { type: String, default: "" },
		mc: { type: String, default: "" },
		isPreloader: Boolean,
	},

	data: () => ({
		brokerLocal: "",
		mcLocal: "",
	}),

	validations: {
		brokerLocal: { required },
		mcLocal: { required },
	},

	watch: {
		newBroker: {
			immediate: true,
			handler(val) {
				this.brokerLocal = String(val || "");
				if (this.$v && this.$v.brokerLocal) this.$v.brokerLocal.$reset();
			},
		},
		mc: {
			immediate: true,
			handler(val) {
				this.mcLocal = String(val || "");
				if (this.$v && this.$v.mcLocal) this.$v.mcLocal.$reset();
			},
		},
	},

	methods: {
		isFieldErr(key) {
			return !!(this.$v && this.$v[key] && this.$v[key].$error);
		},

		onInput({ value }, key) {
			this[key] = value;
			if (this.$v && this.$v[key]) this.$v[key].$touch();
		},

		onSave() {
			if (!this.$v) return; // на всякий случай

			this.$v.$touch();
			if (this.$v.$invalid) return;

			this.$emit("updateSaveBroker", {
				broker: this.brokerLocal,
				broker_mc: this.mcLocal,
			});
		},

		onClose() {
			if (this.$v) this.$v.$reset();
			this.$emit("updateCloseBrokerDialog");
		},
	},
};
</script>

<style scoped lang="scss">
@import "../dialog";
</style>
